'use client'
import React from 'react'
import Heading from './Heading'
import { useAds } from '@/hooks/useAds'
import { Advertisement } from '@/models/ads.model'
import Link from 'next/link'
import Image from 'next/image'
import { SwiperSlide, Swiper } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { Autoplay } from 'swiper/modules'

const AdsArticles = () => {
  const { data } = useAds()

  return (
    <>
      <Heading>Quảng cáo</Heading>
      {/* Swiper component for automatic image slide */}
      <Swiper
        className="mb-5"
        modules={[Autoplay]}
        spaceBetween={10} // Khoảng cách giữa các slide
        slidesPerView={1} // Chỉ hiển thị một slide mỗi lần
        loop
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={false} // Ẩn pagination (chấm tròn)
        navigation={false} // Ẩn các nút next/prev
      >
        <SwiperSlide>
          <article className="w-full h-auto relative">
            <Link href="/" target="_blank" rel="noopener noreferrer">
              <Image
                src="/Image/Halfpage_AD_300x600px_1.jpg"
                alt="Halfpage_AD_300x600px"
                width={300}
                height={300}
                className="object-cover"
                layout="responsive"
              />
            </Link>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <article className="w-full h-auto relative">
            <Link href="/" target="_blank" rel="noopener noreferrer">
              <Image
                src="/Image/Halfpage_AD_300x600px_2.jpg"
                alt="Halfpage_AD_300x600px"
                width={300}
                height={300}
                className="object-cover"
                layout="responsive"
              />
            </Link>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <article className="w-full h-auto relative">
            <Link href="/" target="_blank" rel="noopener noreferrer">
              <Image
                src="/Image/Halfpage_AD_300x600px_3.jpg"
                alt="Halfpage_AD_300x600px"
                width={300}
                height={300}
                className="object-cover"
                layout="responsive"
              />
            </Link>
          </article>
        </SwiperSlide>
      </Swiper>
      <ul>
        {data?.map((ad: Advertisement) => {
          // Kiểm tra và lấy URL hợp lệ
          const url = ad.url ? ad.url.split('iamtapnews.com')[1] || ad.url : '#'

          return (
            <li key={ad.id} className="mb-6">
              <article className="w-full h-auto relative">
                <Link href={url} target="_blank" rel="noopener noreferrer">
                  <Image
                    src={
                      `${process.env.NEXT_PUBLIC_IMAGE_URL}${ad.imageUrl}` ||
                      '/placeholder-image.jpg'
                    }
                    alt={ad.name || 'Quảng cáo'}
                    width={300}
                    height={300}
                    className="object-cover"
                    layout="responsive"
                  />
                </Link>
              </article>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default AdsArticles
